import React, { useState, useEffect, useRef } from "react";
import { FaSave, FaSearch } from "react-icons/fa";
import { Card, CardContent, Box, CardHeader, Button,Tooltip } from "@mui/material";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider
} from "@mui/material";
import { GoDot } from "react-icons/go";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import axios from "axios";
import { MdCancel, MdSave } from "react-icons/md";
import { ImCancelCircle } from "react-icons/im";
import RefreshIcon from '@mui/icons-material/Refresh';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { TiArrowRightThick } from "react-icons/ti";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import { FiEdit, FiInfo } from "react-icons/fi";
import { IoMdSearch } from "react-icons/io";
import Modal from "@mui/material/Modal";
import { toast, ToastContainer } from "react-toastify";
import Records from "./Records";
const RenderCurationTransposedTable = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(4); // Default to 3 cards
  const carouselRef = useRef(null);
  const [Command,setCommand]=useState();
  const [openModel, setOpenModel] = React.useState(false);
  const [openConfirmSave, setOpenConfirmSave] = useState(false);
  const [EditId,SetEditId]=useState(null);
  const [desId , setDesId]=useState(null)
  const [username,setUsername]=useState(null);
  const [refreshStatus,setRefreshStatus] = useState("NO");
  const [refreshId,setRefreshId] = useState(null);
  const [refreshUser,setRefreshUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState(Command);
  const {
    records,
    setRecords,
    editableFields,
    setEditableFields
  } = props;

  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});
  // Function to update cards to show based on container width
  useEffect(() => {
    // Scroll to the top of the page on component mount
    window.scrollTo(0, 0);
    const storedData = localStorage.getItem('username');
    console.log(storedData,"nnnnnnnnnnnnnn");
    setUsername(storedData);
    
    
    
  }, []);  // Empty dependency array to only run on component mount
  const startCardIndex = currentIndex + 1;
  const endCardIndex = Math.min(currentIndex + cardsToShow, records.length);
  const totalEntries = records.length;
  const updateCardsToShow = () => {
    if (!carouselRef.current) return;

    const width = carouselRef.current.clientWidth;
    console.log(width, "www");

    if (width < 680) {
      setCardsToShow(1);
    } else if (width < 1000) {
      setCardsToShow(2);
     } 
    //else if(width<1250){
    //   setCardsToShow(3);
    // }
     else {
      setCardsToShow(3);
    }
  };

  useEffect(() => {
    updateCardsToShow(); // Set initial cards to show

    const observer = new ResizeObserver(updateCardsToShow);
    if (carouselRef.current) {
      observer.observe(carouselRef.current);
    }

    return () => {
      if (carouselRef.current) {
        observer.unobserve(carouselRef.current);
      }
    };
  }, []);
  const handleOpen = (str,id) => {
    setCommand(str);
    setDesId(id);
    setOpenModel(true);
  };
  const handleClose = () => {
    setIsEditing(false)
    setOpenModel(false);
  };
  const nextCard = () => {
    // SetEditId(null)
    if (currentIndex < records?.length - cardsToShow) {
      setCurrentIndex(currentIndex + cardsToShow);
    }
  };

  const prevCard = () => {
    // SetEditId(null)
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - cardsToShow);
    }
  };
  useEffect(()=>{
    console.log(editableFields,"child",EditId);
  
  },[editableFields,EditId])
  const handleEditClick = (id) => {
    SetEditId(id);
    const index = records.findIndex((item) => item.id === id);
    setEditableFields({
      ...records[index],
    });
  };
  const handleInputChange = ( fieldKey, value) => {
    console.log(fieldKey,value,"hello");
    
    if (
      fieldKey === "curation_end_time" &&
      value < editableFields?.curation_start_time
    ) {
      warnToast("endTime")
      return;
    }
    if (
      fieldKey === "curation_start_time" &&
      value > editableFields?.curation_end_time
    ) {
      warnToast("startTime")
      return;
    }
    setEditableFields((prev) => ({
      ...prev,
      [fieldKey]: value || prev[fieldKey],
    }));
  };

  const handleArrivedChange = (value) => {
    setEditableFields((prev) => ({
      ...prev,
      no_of_files: {
        ...prev.no_of_files,
        Arrived: value, // Only update the Arrived key
      },
    }));
  };
  useEffect(() => {
    if (Number(editableFields?.no_of_files?.Arrived) > Number(editableFields?.no_of_files?.Expected)) {
      setEditableFields((prevData) => ({
        ...prevData,
        no_of_files: {
          ...prevData.no_of_files,
          Arrived: editableFields?.no_of_files?.Expected
        }
      }));
    }
  },[editableFields])
  const fieldMappings = [
    { label: "Curation Name", key: "curation_name", editable: false },
    {
      label: "Frequency",
      key: "frequency",
    },
    {
      label: "No of Files (Expected/Arrived)",
      key: "no_of_files",
      editable: true,
    },
    {
      label: "Arrival Datetime",
      key: "arrival_datetime",
      editable: true,
      type: "datetime",
    },
    {
      label: "Load Datetime",
      key: "load_datetime",
      editable: true,
      type: "datetime",
    },
    {
      label: "Curation Date",
      key: "curation_date",
      // editable: true,
      // type: "datetime",
    },
    {
      label: "Curation Start Time",
      key: "curation_start_time",
      editable: true,
      type: "time",
    },
    {
      label: "Curation End Time",
      key: "curation_end_time",
      editable: true,
      type: "time",
    },
    { label: "Time Taken", key: "time_taken",type:'time' },
    {
      label: "Last Load Date",
      key: "last_load_datetime",
      editable: true,
      type: "datetime",
    },
    {
      label: "Last Curation Date",
      key: "last_curation_datetime",
      editable: true,
      type: "datetime",
    },
    // {
    //   label: "Dashboards Connected",
    //   key: "dashboards_connected",
    // },
    // {
    //   label: "Snowflake Validation Status",
    //   key: "snowflake_validation_status",
    //   editable: true,
    // },
    // {
    //   label: "Snowflake Validated By",
    //   key: "snowflake_validated_by",
    //   editable: true,
    // },
    {
      label: "AceDO Validation Status",
      key: "acedo_validation_status",
      editable: true,
    },
    // {
    //   label: "Descriptie Analysis Insights",
    //   key: "Descriptive_Analysis_Insights",
    //   editable: true,
    // },
    { label: "Validated by", key: "validated_by"},
    { label: "Created at", key: "created_at", editable: false },
    { label: "Refreshed by", key: "refreshed_by" },
  ];


  function formatDate(date, type) {
    const dateVal = new Date(date);

    // Local time
    const localYear = dateVal.getFullYear();
    const localMonth = String(dateVal.getMonth() + 1).padStart(2, '0');
    const localDay = String(dateVal.getDate()).padStart(2, '0');
    const localHours = String(dateVal.getHours()).padStart(2, '0');
    const localMinutes = String(dateVal.getMinutes()).padStart(2, '0');

    // UTC time
    const utcYear = dateVal.getUTCFullYear();
    const utcMonth = String(dateVal.getUTCMonth() + 1).padStart(2, '0');
    const utcDay = String(dateVal.getUTCDate()).padStart(2, '0');
    const utcHours = String(dateVal.getUTCHours()).padStart(2, '0');
    const utcMinutes = String(dateVal.getUTCMinutes()).padStart(2, '0');

    const utcMonthName = dateVal.toLocaleString('default', { month: 'long', timeZone: 'UTC' }).slice(0, 3).toUpperCase();
    
    if (type === 'textfield') {
        // Local time formatting for textfield input
        // return `${localYear}-${localMonth}-${localDay}T${localHours}:${localMinutes}`;
        return `${utcYear}-${utcMonth}-${utcDay}T${utcHours}:${utcMinutes}`;
    }else if (type === "date"){
      return `${utcYear}-${utcMonth}-${utcDay}`
    }else if (type === "datetextfield"){
      return `${utcDay}-${utcMonth}-${utcYear}`
    } else {
        // UTC formatting with abbreviated month
        return `${utcDay}-${utcMonth}-${utcYear} ${utcHours}:${utcMinutes}`;
    }
}
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
   
  };

  const isoDate = new Date();
  const [year, month, day] = isoDate.toISOString().split('T')[0].split('-');
  const hours = String(isoDate.getHours()).padStart(2, '0');
  const minutes = String(isoDate.getMinutes()).padStart(2, '0');
  const seconds = String(isoDate.getSeconds()).padStart(2, '0');
  
  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  const handleSaveClick = async (id, val) => {
    console.log("Editable Fields Before Save:", editableFields);  // Check updated values
    
    try {
      if (refreshId) {
        // If refreshId exists, handle it differently
        const refUser = localStorage.getItem('username');
        setRefreshUser(refUser);
        setRefreshStatus('YES');
        const finalData = {
          ...refreshId,
          refreshed_by: refUser,
          refreshed_status: 'YES',
          refreshed_datetime:formattedDate,
        };
  
        const headers = {
          "Content-Type": "application/json",
          "X-CSRFToken": cookies.csrftoken,
        };
        const apiUrl = `/update-curation-details/${id}/`;
        await axios.put(apiUrl, finalData, { headers });
  
        props.fetchRecords();
        setOpenConfirmSave(false);
      } else {
        SetEditId(null);
        let finalData;
        if (val === "command") {
          finalData = {
            ...editableFields,
            Descriptive_Analysis_Insights: editableFields["Descriptive_Analysis_Insights"],
            validated_by: username,
          };
        } else {
          const timeTaken = calculateTimeTaken(
            editableFields.curation_start_time,
            editableFields.curation_end_time
          );
          finalData = {
            ...editableFields,
            time_taken: timeTaken,
            validated_by: username,
          };
        }
  
        const headers = {
          "Content-Type": "application/json",
          "X-CSRFToken": cookies.csrftoken,
        };
        const apiUrl = `/update-curation-details/${id}/`;
        await axios.put(apiUrl, finalData, { headers });
  
        props.fetchRecords();
        setOpenModel(false);
        setIsEditing(false);
      }
    } catch (error) {
      console.error("Error updating record:", error);
    }
  };
  
  const handleEdit = () => {
    setIsEditing(true);
    handleEditClick() // Enable edit mode
  };

  const handlerefresh = (id) => {
    setRefreshId(id);
    setOpenConfirmSave(true)
    console.log(id,"--------------------record id ----------------------")
  }
  const handlerefreshConfirm = (e) =>{
    console.log(e,"-------------================------")
    
    handleSaveClick(refreshId?.id)
  }

  const handleSave = () => {
    // Save the changes and disable edit mode
    console.log(Command,"command");
    
    setIsEditing(false);
    setOpenModel(false);
  };

  const handleInputEdit = (e) => {
    setCommand(e.target.value);
  };

  const warnToast = (val) => {
    if(val==="endTime"){
      toast.warn("End time cannot be earlier than start time.", {
        position: "top-right",
        autoClose: 5000,  
      });
    }
    if(val==="startTime"){
      toast.warn("The start time should not exceed the end time.", {
        position: "top-right",
        autoClose: 5000,  
      });
    }
  };
  const calculateTimeTaken = (startTime, endTime) => {
    // Split the time strings into hours, minutes, and optional seconds
    const [startHours, startMinutes, startSeconds = 0] = startTime.split(":").map(Number);
    const [endHours, endMinutes, endSeconds = 0] = endTime.split(":").map(Number);
  
    // Convert the start and end times to total seconds since the start of the day
    const startTotalSeconds = startHours * 3600 + startMinutes * 60 + startSeconds;
    const endTotalSeconds = endHours * 3600 + endMinutes * 60 + endSeconds;
  
    let timeDifferenceInSeconds = endTotalSeconds - startTotalSeconds;
  
    if (timeDifferenceInSeconds < 0) {
      timeDifferenceInSeconds += 24 * 3600; 
    }
  
    // Convert the difference back to hours and minutes
    const hours = Math.floor(timeDifferenceInSeconds / 3600);
    const minutes = Math.floor((timeDifferenceInSeconds % 3600) / 60);
  
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  };
  // Example usage:
  // console.log(calculateTimeTaken("17:01:00", "18:11:45")); // Output: "01:12:45"
  
  const timeString =(val) => {
    const timeStr = val;
    if(timeStr){   
      const [hours, minutes] = timeStr.split(":");
      return `${hours} hrs ${minutes} mins`;
    }
  }

  return (
    <>
    <Card ref={carouselRef} sx={{boxShadow:"none",borderRadius:'16px'}} >
      {console.log(Command)
      }
    <div
      style={{
        display: "flex",
      }}
      
    >
    <div
      style={{
        display: "flex",
        overflowX: "hidden",
        alignItems: "stretch",
        // boxShadow:
        // "rgba(149, 157, 165, 0.1) 0px 3px 6px 0px, rgba(149, 157, 165, 0.1) 0px -4px 6px 0px",
        margin:"0.3rem",
        marginTop:"0.5rem",
        paddingRight:"1%",
        paddingBottom:"1%",
        width:"100%",
        // borderRadius:"10px",
      }}
    >
      <div
        style={{
          flex: "0 0 auto",
          minWidth: "20%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Card
          sx={{
            height: "100%",
            boxShadow: "none",
            borderRadius: "5px 0px 0px 5px",
            backgroundColor: "#fff",
          }}
        >
          <div
            style={{
              color: "#000",
              backgroundColor: "#fff",
              padding: "15px 0px",
              marginLeft:"1.4rem",
              fontWeight: "bold",
              borderBottom:"1px solid #eaeaea",
              // fontSize:"18px"
              // width:"70%",
            }}
          >
            {fieldMappings[0].label}
          </div>
          
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "8px 0px",
              backgroundColor:"#fff",
              margin:"1rem"
            }}
          >

            {fieldMappings?.map(
              (field, fieldIndex) =>
                fieldIndex > 0 && (

                  <Box key={fieldIndex} sx={{ marginBottom: EditId===null? "0.55rem" :"1.06rem"}}>
                    
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: "bold", fontSize: "14px" }}
                    >
                      {/* <TiArrowRightThick
                        style={{ marginRight: "0.6rem", color: "#6a6b6d" }}
                      /> */}
                      <GoDot
                        style={{ marginRight: "0.6rem", color: "#6a6b6d" }}
                        />
                      {field.label}
                    </Typography>
                  </Box>
                )
            )}
          </CardContent>
        </Card>
      </div>

      <div

        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: records.length === 0 ? "center" : "",
          alignItems: records.length === 0 ? "center" : "",
          flexWrap: "nowrap",
          overflowX: "hidden",
          flex: "1 1 auto",
          borderRadius: "0px 5px 5px 0px",
          backgroundColor: "#fff",
          padding: "9px 6px",
          position: "relative",

          // maxWidth:
          // cardsToShow === 4 ? "66rem" : cardsToShow === 3 ? "49rem" : cardsToShow === 2 ? "33rem" : "17rem",
        }}
      >
        {/* {currentIndex > 0 && ( */}
        {records.length !== 0 &&
          <IconButton
            sx={{
              bgcolor: "#fff",
              boxShadow:
                "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
              height: "2.5rem",
              width: "2.5rem",
              marginY: "auto",
              position: "absolute",
              top: EditId===null? "250px":"300px",
              left: "0px",
              zIndex: "2",
            }}
            onClick={prevCard}
            disabled={(currentIndex > 0)!==true }
          >
            {" "}
            <MdOutlineKeyboardArrowLeft />
          </IconButton>
        }
        {/* )} */}
        {records.length === 0 ? (
          <>
            <span
              style={{
                width: "100rem",
                height: "30%",
                color: "#707070",
                textAlign: "center",
                margin:"0 20rem",
                // backgroundColor:"purple",
                padding:"0 30px"
              }}
            >
              <div style={{ fontSize: "80px" }}>
                <IoMdSearch />
              </div>
              <Typography
                sx={{  bottom: "45px", width: "40rem" }}
              >
                No records available{" "}
              </Typography>
            </span>
          </>
        ) : (
          records
            .slice(currentIndex, currentIndex + cardsToShow)
            .map((record, index) => (
              <div
                key={index}
                style={{
                  flex: "0 0 auto",
                  width: "16.4rem",
                  marginRight: "1rem",
                  display: "flex",
                  flexDirection: "column",
                  // marginX: "0.3rem",
                  // marginLeft: "0.5rem",
                }}
              >
                <Card
                  sx={{
                    position: "relative",
                    height: "100%",
                    cursor: "pointer",
                    // borderRadius: "12px",
                    transition: ".2s",
                    backgroundColor: "#EBF4FF",
                    padding: "10px",
                    ":hover": {
                      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                      transform: "scale(1.02)",
                    },
                  }}
                >
                  
                  {
                    record?.["curation_name"]!==null &&
                        <div
                          style={{
                            color: "#000",
                            fontWeight: "bold",
                            padding: "0px 7px 11px 7px",
                            // textAlign: EditId !== record.id ? "center" : "left",
                            textAlign: "left",
                            backgroundColor: "#f0f2f8",
                          }}
                        >
                          <div
                            className="text-truncate"
                            style={{ width: "76%" }}
                          >
                            {" "}
                            <Tooltip title={record?.["curation_name"]}>{record["curation_name"]}</Tooltip> 
                          </div>
                        </div>
                  }
                  <CardContent
                    sx={{
                      height: "93%",
                      paddingTop: "12px",
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                    }}
                  >
                    
                    {fieldMappings.map((field, fieldIndex) => (
                      <Box
                        key={fieldIndex}
                        sx={{
                          marginBottom: EditId!==null ? EditId===record?.id ? 
                          '0.7rem':'1.06rem' :( fieldIndex === fieldMappings.length - 1
                                ? "0.3rem"
                                : "0.6rem" ),
                        }}
                        className="text-truncate"
                      >
                        {/* {(record['refreshed_status'] =="YES") &&<div class="ribbon-2">Refreshed</div>} */}
                        
                        {field.key === "no_of_files" ? (
                          <>
                            <Typography
                              sx={{ fontSize: "14px", color: "#333" }}
                            >{
                            }
                              {EditId === record?.id && field.editable ? (
                                <div className="d-flex">

                                      <span
                                      style={{
                                        backgroundColor: "#fdca02",
                                        padding: "5px 2px 2px 2px",
                                        borderRadius: "7px",
                                        color: "#000",
                                        marginRight:"0.2rem"
                                      }}
                                    >
                                      Expected:{" "}
                                      <strong>
                                        {Number(record?.no_of_files?.Expected) || "-"}
                                      </strong>
                                    </span> 
                                    <Divider orientation="vertical" flexItem sx={{padding:"0 2px"}}/>
                                    <input
                                    className="form-control form-control-sm w-50"
                                      type="number"
                                      onWheel={(e) => e.target.blur()}
                                      value={
                                        editableFields?.no_of_files?.Arrived || ""
                                      }
                                      onChange={(e) =>
                                        handleArrivedChange(e.target.value)
                                      }
                                      style={{
                                        width: "100%",
                                        marginLeft:"0.35rem"
                                      }}
                                      min={0}
                                      max={record.no_of_files?.Expected}
                                    />
                                </div>
                              ) : (
                                <>
                                   <span
                                    style={{
                                      backgroundColor: "#fdca02",
                                      padding: "2px 4px 2px 4px",
                                      borderRadius: "7px",
                                      color: "#000",
                                    }}
                                  >
                                    Expected:{" "}
                                    <strong>
                                      {Number(record.no_of_files?.Expected) || "-"}
                                    </strong>
                                  </span>   |{" "}
                                  <span
                                    style={{
                                      backgroundColor: Number(record.no_of_files?.Arrived) < Number(record.no_of_files?.Expected) ? "#e5453d" : "#1e8fff",
                                      padding: "2px 4px 2px 4px",
                                      borderRadius: "7px",
                                      color: "#fff",
                                    }}
                                  >
                                    {" "}
                                    Arrived:
                                    <strong>
                                      {" "}
                                      <span
                                      style={{
                                        color: "#fff",
                                      }}
                                    >
                                      {Number(record.no_of_files?.Arrived)|| "-"}
                                    </span>
                                    </strong>
                                  </span>{" "}
                               
                               
                                </>
                              )}
                            </Typography>
                          </>
                        ) : field.editable ? (
                          EditId === record?.id ? (
                            field.type === "datetime" ? (
                              <input
                              className="form-control form-control-sm"
                                type={(field.key==="last_curation_datetime"||field.key === "last_load_datetime")?"date":"datetime-local"}
                                defaultValue={
                                  field.key === "last_curation_datetime" || field.key === "last_load_datetime"
                                    ? 
                                    (editableFields[field.key] ? formatDate(editableFields[field.key], 'date') : "")
                                    : (editableFields[field.key] ? formatDate(editableFields[field.key], 'textfield') : "")
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    field.key,
                                    e.target.value
                                  )
                                }
                                style={{ width: "100%" }}
                              />
                            ) 
                            : field.type === "time" ? (
                              <input
                              className="form-control form-control-sm"
                                type="time"
                                value={editableFields[field.key] || ""}
                                onChange={(e) =>
                                  handleInputChange(
                                    field.key,
                                    e.target.value
                                  )
                                }
                                style={{ width: "100%" }}
                              />
                            )
                             : (
                              field.key==="acedo_validation_status" ?
                              <select className="form-control form-control-sm" name="" id="" defaultValue={editableFields[field.key] && editableFields[field.key] || ""}
                               onChange={(e) =>
                                  handleInputChange(
                                    field.key,
                                    e.target.value
                                  )
                                }>
                                <option value="yes">YES</option>
                                <option value="no">NO</option>
                              </select>
                              :
                              <input
                              className="form-control form-control-sm"
                                type="text"
                                value={editableFields[field.key] && editableFields[field.key] || ""}
                                onChange={(e) =>
                                  handleInputChange(
                                    field.key,
                                    e.target.value
                                  )
                                }
                                style={{ width: "100%" }}
                              />
                            )
                          ) : (
                            <Typography sx={{ fontSize: "14px", color:  "#333" }}>
                            {field.type === "datetime" ? (
                              (field.key === "last_curation_datetime" || field.key === "last_load_datetime") ?
                                (record[field.key] !== null ? formatDate(record[field.key], "datetextfield") : "-") :
                                (record[field.key] !== null ? formatDate(record[field.key]) : "-")
                            ) : (
                              field?.key !== "validated_by" && (field.type === "time" ? 
                                timeString(record[field.key]) :
                                field.key === "acedo_validation_status" ? 
                                <div style={{color:record[field.key]=='no'? 'red' : '#333'}}>
                                  {  record[field.key]?.toUpperCase()}
                                </div>
                               : 
                                record[field.key] || "-"
                              )
                            )}
                            {field?.key === "validated_by" && (
                              <div
                                style={{
                                  backgroundColor: "#ee8204",
                                  padding: "2px 4px",
                                  borderRadius: "7px",
                                  color: "black",
                                  textAlign: "center",
                                }}
                              >
                                {record[field.key] || "-"}
                              </div>
                            )}
                           
                          </Typography>
                          
                          )
                        ) :
                         ( field.key !== "curation_name" && field.key === "created_at"  ? (
                            <Typography
                              sx={{
                                fontSize: "14px",
                                // color: "#fff",
                                // bgcolor: "#3798b8",
                                // padding: "2px 4px 2px 4px",
                                // borderRadius: "7px",
                                // textAlign:"center",
                                // marginTop:"0rem"
                              }}
                            >
                              {record[field.key]!==null && formatDate(record[field.key]) || "-"}
                            </Typography>
                          ) :
                          ( field.key === "time_taken" ?
                            <Typography
                            sx={{
                              fontSize: "14px",
                              color: "#333",
                              // padding: "2px 4px 2px 4px",
                              // borderRadius: "7px",
                            }}>
                                {timeString(record[field.key])}
                            </Typography>
                            :
                            field.key === "validated_by" ?
                            <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "14px",
                              // color: "#333",
                              // padding: "2px 4px 2px 4px",
                              // borderRadius: "7px",
                              // textAlign:"center",
                              // marginTop:"1.2rem",
                              // bgcolor:"#f28304"
                            }}>
                             { record[field.key]}
                            </Typography>
                           :
                           field.key === "refreshed_by" ?
                            <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "14px",
                              // color: "#333",
                              // padding: "2px 4px 2px 4px",
                              // borderRadius: "7px",
                              // textAlign:"center",
                              // marginTop:"1.2rem",
                              // bgcolor:"#f28304"
                            }}>
                             { record[field.key] || "-"}
                            </Typography>
                           :
                            field.key === "curation_date" ?
                            <Typography
                            sx={{
                               fontWeight: "bold",
                              fontSize: "14px",
                              // color: "#333",
                              // padding: "2px 4px 2px 4px",
                              // borderRadius: "7px",
                              // textAlign:"center",
                              // marginTop:"1.2rem",
                              // bgcolor:"#f28304"
                            }}>
                          {(() => {
                            const dateVal = new Date(record[field.key]); 
                            const day = String(dateVal.getDate()).padStart(2, '0'); 
                            const month = String(dateVal.getMonth() + 1).padStart(2, '0');
                            const year = String(dateVal.getFullYear());
                            return `${day}-${month}-${year}`; 
                          })()}
                            </Typography>
                            :
                          field.key === "dashboards_connected" ?
                          <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#333",
                            borderRadius: "7px",
                            // marginTop:"1.2rem",
                          }}
                          className="text-truncate"
                          >
                            <Tooltip title={record[field.key]}>
                           { record[field.key] || "-"}
                            </Tooltip>
                          </Typography>
                          :
                          field.key === "frequency" &&
                          <div className="d-flex" style={{justifyContent:'space-between'}}>

                          <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#333",
                            padding: "2px 4px 2px 4px",
                            borderRadius: "7px",
                          }}>
                           { record[field.key].charAt(0).toUpperCase() + record[field.key].slice(1).toLowerCase()}
                          </Typography>
                          {(record['refreshed_status'] =="YES") &&
                          <div  style={{ color:'#00cc99',padding:'2px 5px',borderRadius:'5px',fontWeight:'650',fontSize:'0.775rem'}}>
                            <TaskAltIcon />
                            <label className="ms-1">REFRESHED</label>
                          </div>} 
                          </div>
                          )
                        )}
                      </Box>
                    ))}
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      {/* <Button sx={{bgcolor:"grey"}} size='small' variant="contained" disableElevation endIcon={<EditIcon />}>
                          Edit 
                        </Button> */}
                    </div>
                  </CardContent>
                  
                  <Tooltip title={ EditId === record?.id ?"Cancel":"Edit"}>
                  <IconButton
                    size="small"
                    sx={{ position: "absolute", top: 7, right: 2 }}
                    onClick={() =>
                      EditId === record?.id
                        ? SetEditId(null)
                        : handleEditClick(record.id)//record.id
                    }
                  >
                    {EditId === record?.id ? <ImCancelCircle /> :<FiEdit/>}
                  </IconButton></Tooltip>
                  {console.log(record,"-----------record----------------")}
                   { (record?.refreshed_status == "NO" ) && 
                  <Tooltip title="Refresh"> 
                    <IconButton size="small"
                    onClick={()=>handlerefresh(record)}
                    sx={{ position: "absolute", top: 5.2, right: 48 }}>
                      <RefreshIcon/>
                    </IconButton>
                  </Tooltip>}
                  
                  <div style={{ position: "absolute", top: 7.5, right: 27 }}>
                 
                  <Tooltip title={ EditId === record?.id ?"Save":"Show Descriptive Analysis Insights"}>
                    <IconButton
                      size="small"
                      color={EditId === record?.id ? "primary":"error"}
                      onClick={() => {
                        EditId === record?.id
                          ?handleSaveClick(record.id)
                          : handleOpen(record?.['Descriptive_Analysis_Insights'],record.id);
                      }}
                    >
                      {EditId === record?.id ? <FaSave /> : <FiInfo />}
                    </IconButton></Tooltip>

                    
                  </div>
                  
                </Card>
              </div>
            ))
        )}
        {/* {currentIndex < records?.length - cardsToShow && ( */}
        {records.length !== 0 &&
          <IconButton
            sx={{
              bgcolor: "#fff",
              boxShadow:
                "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
              height: "2.5rem",
              width: "2.5rem",
              marginY: "auto",
              position: "absolute",
              top: EditId===null? "250px":"300px",
              right: "0px",
              zIndex: "2",
            }}
            onClick={nextCard}
            disabled={(currentIndex < records?.length - cardsToShow)!==true }
          >
            {" "}
            <MdOutlineKeyboardArrowRight />
          </IconButton>
          
          }
        {/* )} */}
        
      </div>
      </div>
      <Modal
        open={openConfirmSave}
        onClose={() => setOpenConfirmSave(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              sx={{ color: "#333", padding: "25px 25px 0px 25px" }}
              component="h2"
            >
              Data cloned to STAGE? 
            </Typography>
          </div>
          <div style={{ padding: "0px 32px 32px 32px" }}>
            <div className="d-flex justify-content-center">
              <Button
                variant="contained"
                className="save-button mx-3"
                onClick={() => setOpenConfirmSave(false)}
                endIcon={<MdCancel />}
                sx={{ mt: 3, background: "#fff", color: "grey" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="save-button"
                onClick={(e)=>handlerefreshConfirm(e)}
                endIcon={<PublishedWithChangesIcon />}
                sx={{ mt: 3, background: "#0576FC" }}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal open={openModel} onClose={handleClose}>
      <Box sx={{ ...style, width: 400 }}>
        <div style={{display:"flex",justifyContent:"center"}}>
            <Typography
              id="modal-modal-title"
              variant="h6"
             
              sx={{padding:"30px 20px 0px 40px"}}
              component="h2"
            >
             Descriptive Analysis Insights
            </Typography>
           </div>
        {isEditing ? (
          <div>
            <TextField
              fullWidth
              defaultValue={Command}
              onChange={(e) =>
                handleInputChange(
                  "Descriptive_Analysis_Insights",
                  e.target.value
                )
              }
              multiline
              style={{padding:"20px"}}
              rows={4}
            />
            <div style={{display:"flex",justifyContent:"center",paddingBottom:"20px"}}>
            <Button onClick={()=>handleSaveClick(desId,"command")
            } sx={{ mt: 2 ,background:"#0576FC",color:"white"}} variant="contained">
              Save
            </Button>
            </div>
           
          </div>
        ) : (
          <div >
            <p id="child-modal-description" style={{padding:"20px",textAlign:"justify"}}>{Command}</p>
            <div style={{display:"flex",justifyContent:"center",paddingBottom:"20px"}}>
            <Button onClick={handleEdit} sx={{ mt: 2,background:"#0576FC",color:"white"  }} variant="outlined" >
              Edit
            </Button>
            </div>

          </div>
        )}
        </Box>
      </Modal>
    </div>
    {totalEntries > 0 && (<Typography variant="body2" sx={{ marginBottom: 2, textAlign: "right",fontSize: "0.975rem",fontWeight: "bold" }}>
  Showing {startCardIndex} to {endCardIndex} of {totalEntries} entries
</Typography>)}</Card>
          <ToastContainer
          toastOptions={{
            style: {
              fontSize: "20px",
              padding: "16px",
              width: "350px",
            },
          }}
        />
    </>
  );
};
export default RenderCurationTransposedTable;